import React, {forwardRef, HTMLProps, Ref} from 'react'
import {NavLink} from 'react-router-dom'
import parse from 'url-parse'
import {ClassName} from './style'

export type LinkProps = {to?: string} & Omit<
	HTMLProps<HTMLAnchorElement>,
	'className'
> & {
		className?: ClassName | string
	}

export const Link: React.FC<LinkProps> = forwardRef(
	(props, ref: Ref<HTMLAnchorElement>) => {
		const {children, as, to, type, target, ...rest} = props
		const href = to
		const parsed = parse(href)
		const isFile = type
			? type === 'file'
			: parsed.pathname
					.split('/')
					.pop()
					.includes('.')
		const isExternal = type
			? type === 'external'
			: parsed.hostname !== window.location.hostname
		let newTarget = target
		if (!target) {
			if (isFile) {
				newTarget = '_blank'
			} else if (isExternal) {
				newTarget = '_blank'
			} else {
				newTarget = '_self'
			}
		}
		const Tag: any = as || (href ? (isFile || isExternal ? 'a' : NavLink) : 'a')
		const attrs =
			isFile || isExternal
				? href
					? {
							href,
							ref,
							target: newTarget,
							rel: isExternal ? 'external nofollow noopener' : null
					  }
					: {}
				: {
						to: href,
						target: newTarget,
						innerRef: ref,
						activeClassName: 'is-active'
				  }
		return (
			<Tag {...attrs} {...rest}>
				{children}
			</Tag>
		)
	}
)
